import { createAction, createReducer } from 'redux-act';
import constants from '../constants';
import { actions as authActions } from './auth';

const goToPage = createAction('go to page');
const goToPreviousPage = createAction('go to previous page');

const initialState = {
  page: constants.pages.CREATE,
  previousPage: null
};

const listenTo = {
  [goToPreviousPage]: state => ({
    ...state,
    page: state.previousPage,
    previousPage: null
  }),
  [goToPage]: (state, page) => ({
    ...state,
    previousPage: state.page !== page ? state.page : state.previousPage,
    page
  }),
  [authActions.login]: state => ({
    ...state,
    page: constants.pages.CREATE
  })
};

export const actions = {
  goToPage,
  goToPreviousPage
};

export default createReducer(listenTo, initialState);



// WEBPACK FOOTER //
// ./src/reducers/pages.js